import React from "react";

const CustomerQuote = ({ name, color, isRight, children }) => {
  return (
    <div className="max-w-sm m-6">
      <div className={`relative bg-${color} text-white p-4 rounded-2xl`}>
        {children}
        <div
          className={`border-${color} absolute ${
            isRight ? `arrow-right right-10` : `arrow-left left-10`
          }`}
        ></div>
      </div>
      <p
        className={`text-white text-20 italic mt-8 px-2 ${
          isRight ? `text-right` : `text-left`
        }`}
      >
        {name}
      </p>
    </div>
  );
};

export default CustomerQuote;
